// extracted by mini-css-extract-plugin
module.exports = {"root":"RuleStatus_root__2C1bF"};